import { IBaseOption } from '../interface/common';

export const mockDataListTemplateOrder: IBaseOption[] = [
  {
    value: '1',
    label: 'Template 1',
  },
];
